const pagesDevicesAddEn = {
  form: {
    navigation: {
      common: {
        acquisitionDate: 'Acquisition Date',
        assetNumber: 'Asset Number',
        assignedAt: 'Assigned At',
        assignedTo: 'Assigned To',
        dateInService: 'Date In Service',
        device: 'Device',
        errorDuplicate: 'Serial number, device management ID, or asset tag is already registered.',
        errorDuplicateAssetTag: 'This asset tag is already registered.',
        errorDuplicateDeviceTag: 'This device management ID is already registered.',
        errorDuplicateSerialNumber: 'The combination of manufacturer and serial number is already registered.',
        serialNumber: 'Serial Number',
        submitButtonLabel: 'Add device',
        unassiged: 'Unassigned'
      },
      completed: {
        completedBy: 'Completed by:',
        goToDevice: 'Go to Device',
        message: 'Device added.',
        result: 'Result'
      },
      steps: {
        assetManagement: {
          assetRadioGroup: {
            equipment: 'Do not register as Fixed Asset',
            fixedAsset: 'Register as Fixed Asset',
            lease: 'Register as Lease'
          },
          assetTagDescription: 'A number for tracking assets.',
          assetTagLabel: 'Asset Number',
          assetTagPlaceholder: 'Input number',
          deviceTagDescription: 'A tag specifically for tracking devices, used when an additional tag is required beyond the asset number.',
          deviceTagLabel: 'Device Tag',
          deviceTagPlaceholder: 'Input tag',
          fixedAssetLabel: 'Fixed Asset',
          fixedAssetSelection: 'This device is a fixed asset.',
          generateLabels: 'Generate Labels',
          labelType: 'Label Type',
          managementLabel: 'Management Label',
          memoLabel: 'Memo',
          memoPlaceholder: 'Takes notes on this device',
          notFixedAssetSelection: 'This device is NOT a fixed asset.',
          tagLabel: 'Tag',
          title: 'Asset Management'
        },
        assignment: {
          allocatePlaceholder: 'Select Place...',
          allocationDateLabel: 'Allocation Date',
          allocationLabel: 'Allocation',
          allocationRadioGroup: {
            allocation: 'Allocate',
            notAllocation: 'No allocation (in stock)'
          },
          assigneeLabel: 'User',
          assignmentDateLabel: 'Assignment Start Date',
          assignmentLabel: 'Assignment',
          assignmentRadioGroup: {
            assignment: 'Assign',
            notAssignment: 'No assignment (in stock)'
          },
          custodyTypeLabel: 'Custody Type',
          custodyTypeOptions: {
            ASSIGNMENT: 'Assignment (Assign to user)',
            IN_STOCK: 'In Stock (Warehousing)',
            PLACEMENT: 'Placement (Install at location)'
          },
          notAssigned: 'Not Assigned',
          placeLabel: 'Installation Location Name',
          placementDateLabel: 'Placement Date',
          storageTypeOptions: {
            IN_STOCK: 'In Stock',
            REFURBISHING: 'Refurbishing',
            TEMPORARILY_STORED: 'Temporarily Stored',
            WAITING_FOR_DISPOSAL: 'Waiting for Disposal'
          },
          title: 'Assignment & Placement & In Stock',
          warehousingDateLabel: 'Warehousing Date',
          warehousingPlaceLabel: 'Storage Site Name'
        },
        basic: {
          assetTagLabel: 'Asset Tag',
          assetTagPlaceholder: 'Enter Asset Tag',
          categoryLabel: 'Category',
          deviceNameLabel: 'Device Name',
          deviceNamePlaceholder: 'Input Device Name',
          deviceTagLabel: 'Inventory ID',
          deviceTagPlaceholder: 'Enter Inventory ID',
          deviceTypeLabel: 'Device Type',
          manufacturerLabel: 'Manufacturer',
          manufacturerPlaceholder: 'Ex) Apple, Google, Microsoft...',
          modelNumberLabel: 'Model Number',
          modelNumberPlaceholder: 'Input Model Number',
          productNameLabel: 'Product Name / Model Name',
          productNamePlaceholder: 'Enter Product Name / Model Name',
          remarksLabel: 'Remarks',
          remarksPlaceholder: 'Enter Remarks',
          serialNumberLabel: 'Serial Number',
          serialNumberPlaceholder: 'Input Serial Number',
          title: 'Basic'
        },
        battery: {
          batteryDesignCapacityMWhLabel: 'Battery Design Capacity (mWh)',
          batteryDesignCapacityMWhPlaceholder: 'Enter Battery Design Capacity (mWh)',
          batteryManufactureDateLabel: 'Battery Manufacture Date',
          batteryManufactureDatePlaceholder: 'Enter Battery Manufacture Date',
          batteryManufacturerLabel: 'Battery Manufacturer',
          batteryManufacturerPlaceholder: 'Enter Battery Manufacturer',
          batteryModelNameLabel: 'Battery Model Name',
          batteryModelNamePlaceholder: 'Enter Battery Model Name',
          batteryPresenceLabel: 'Battery Present',
          batterySerialNumberLabel: 'Battery Serial Number',
          batterySerialNumberPlaceholder: 'Enter Battery Serial Number',
          batteryTypeLabel: 'Battery Type',
          batteryTypePlaceholder: 'Enter Battery Type',
          title: 'Battery'
        },
        firmware: {
          biosLockWriteProtectionLabel: 'BIOS Lock Write Protection',
          biosPasswordSetLabel: 'BIOS Password Set',
          biosReleaseDateLabel: 'BIOS Release Date',
          biosReleaseDatePlaceholder: 'Select BIOS Release Date',
          biosRomSizeBytesLabel: 'BIOS ROM Size (Bytes)',
          biosRomSizeBytesPlaceholder: 'Enter BIOS ROM Size in Bytes',
          biosUpdateEnabledLabel: 'BIOS Update Enabled',
          biosVendorLabel: 'BIOS Vendor',
          biosVendorPlaceholder: 'Enter BIOS Vendor',
          biosVersionLabel: 'BIOS Version',
          biosVersionPlaceholder: 'Enter BIOS Version',
          bootSequenceOrderLabel: 'Boot Sequence / Order',
          bootSequenceOrderPlaceholder: 'Enter Boot Sequence or Order',
          firmwareModeLabel: 'Firmware Mode',
          firmwareModePlaceholder: 'Enter Firmware Mode',
          firmwareTypeLabel: 'Firmware Type',
          firmwareTypePlaceholder: 'Enter Firmware Type',
          hardwareEncryptionSupportLabel: 'Hardware Encryption Support',
          intelTrustedExecutionTechnologyLabel: 'Intel Trusted Execution Technology',
          motherboardModelLabel: 'Motherboard Model',
          motherboardModelPlaceholder: 'Enter Motherboard Model',
          oemBiosCustomizationLabel: 'OEM BIOS Customization',
          oemBiosCustomizationPlaceholder: 'Enter OEM BIOS Customization',
          pxeBootEnabledLabel: 'PXE Boot Enabled',
          secureBootEnabledLabel: 'Secure Boot Enabled',
          smbiosVersionLabel: 'SMBIOS Version',
          smbiosVersionPlaceholder: 'Enter SMBIOS Version',
          systemManufacturerLabel: 'System Manufacturer',
          systemManufacturerPlaceholder: 'Enter System Manufacturer',
          systemModelLabel: 'System Model',
          systemModelPlaceholder: 'Enter System Model',
          systemSerialNumberLabel: 'System Serial Number',
          systemSerialNumberPlaceholder: 'Enter System Serial Number',
          systemUuidLabel: 'System UUID',
          systemUuidPlaceholder: 'Enter System UUID',
          title: 'BIOS/Firmware',
          tpmEnabledLabel: 'TPM Enabled',
          tpmVersionLabel: 'TPM Version',
          tpmVersionPlaceholder: 'Enter TPM Version',
          wakeOnLanEnabledLabel: 'Wake-on-LAN Status'
        },
        generatePdf: {
          checkGenerationStatus: "Click the 'Reload' button to check generation status",
          clickCompleteAfterPrint: "Click the 'Mark as completed' button after printing is finished",
          deviceManagementLabel: 'Device management label',
          failedToCompleteTask: 'Failed to complete task',
          generatePdf: 'Generate PDF',
          generatingPdf: 'Generating PDF...',
          markAsCompleted: 'Mark as completed',
          pdfGenerationRequestFailed: 'Failed to send PDF generation request',
          // Additional keys needed by the component
          pdfReady: 'PDF generation completed',
          popupBlocked: 'Popup was blocked. Please check your browser settings.',
          preparingPdfGeneration: 'Preparing PDF generation...',
          print: 'Print',
          printAgain: 'Print again',
          printCompleted: 'Print task completed',
          printDialogOpened: 'Print dialog opened',
          reload: 'Reload',
          retry: 'Retry',
          successToCompleteTask: 'Task completed successfully',
          taskCompletionFailed: 'Task completion process failed',
          waitForLabelGeneration: 'Please wait for label generation task to complete'
        },
        gpu: {
          gpuArchitectureLabel: 'GPU Architecture',
          gpuArchitecturePlaceholder: 'Enter GPU Architecture',
          gpuClockSpeedBaseHzLabel: 'Clock Speed Base (Hz)',
          gpuClockSpeedBaseHzPlaceholder: 'Enter Clock Speed Base (Hz)',
          gpuClockSpeedBoostHzLabel: 'Clock Speed Boost (Hz)',
          gpuClockSpeedBoostHzPlaceholder: 'Enter Clock Speed Boost (Hz)',
          gpuCudaCoresLabel: 'CUDA Cores',
          gpuCudaCoresPlaceholder: 'Enter CUDA Cores',
          gpuDedicatedMemoryBytesLabel: 'Dedicated Memory (Bytes)',
          gpuDedicatedMemoryBytesPlaceholder: 'Enter Dedicated Memory (Bytes)',
          gpuDriverProviderLabel: 'Driver Provider',
          gpuDriverProviderPlaceholder: 'Enter Driver Provider',
          gpuDriverVersionLabel: 'Driver Version',
          gpuDriverVersionPlaceholder: 'Enter Driver Version',
          gpuGenerationLabel: 'GPU Generation',
          gpuGenerationPlaceholder: 'Enter GPU Generation',
          gpuHardwareAccelerationLabel: 'Hardware Acceleration Enabled',
          gpuMaxDisplaySupportLabel: 'Max Display Support',
          gpuMaxDisplaySupportPlaceholder: 'Enter Max Display Support',
          gpuModelNumberLabel: 'GPU Model Number',
          gpuModelNumberPlaceholder: 'Enter GPU Model Number',
          gpuNameLabel: 'GPU Name',
          gpuNamePlaceholder: 'Enter GPU Name',
          gpuShaderUnitsLabel: 'Shader Units',
          gpuShaderUnitsPlaceholder: 'Enter Shader Units',
          gpuSharedMemoryBytesLabel: 'Shared Memory (Bytes)',
          gpuSharedMemoryBytesPlaceholder: 'Enter Shared Memory (Bytes)',
          gpuSupportedApisLabel: 'Supported APIs',
          gpuSupportedApisPlaceholder: 'Enter Supported APIs',
          gpuVendorLabel: 'GPU Vendor',
          gpuVendorPlaceholder: 'Enter GPU Vendor',
          title: 'GPU'
        },
        hardware: {
          addAnother: 'Add Another',
          capacityLabel: 'Capacity',
          chipLabel: 'Chip',
          chipPlaceholder: 'Ex) Core i7-9900K , Ryzen 7 5800H...',
          coreLabel: 'core',
          cpuArchitectureLabel: 'CPU Architecture',
          cpuArchitecturePlaceholder: 'Ex) arm, x86_64...',
          cpuClockLabel: 'CPU Clock',
          cpuCoreLabel: 'CPU Core',
          cpuSpecLabel: 'CPU Spec',
          displayLabel: 'Display',
          heightLabel: 'Height',
          manufacturerLabel: 'CPU Manufacturer',
          manufacturerPlaceholder: 'Ex) Intel, AMD, Apple...',
          memoryLabel: 'Memory',
          networkInterfaceLabel: 'Network Interface',
          networkInterfaceMacAddressLabel: 'MAC Address',
          networkInterfaceTypeLabel: 'Interface Type',
          portCountLabel: 'Port Number',
          portLabel: 'External Port',
          portSpecificationLabel: 'Port Specification',
          portSpecificationPlaceholder: 'Ex) 2.0, 3.2...',
          portTypeLabel: 'Port Type',
          processorInfoLabel: 'Processor Info',
          processorLabel: 'CPU Processor',
          refreshRateLabel: 'Refresh Rate',
          resolutionLabel: 'Resolution',
          selectTypePlaceholder: 'Select Type...',
          sizeLabel: 'Size',
          storageSizeLabel: 'Storage Size',
          storageTypeLabel: 'Storage Type',
          title: 'Hardware',
          typeNumberPlaceholder: 'Type number',
          widthLabel: 'Width'
        },
        license: {
          licenseIdLabel: 'License ID',
          licenseIdPlaceholder: 'Enter License ID',
          title: 'License'
        },
        monitor: {
          activePortUsedLabel: 'Active Port Used',
          activePortUsedPlaceholder: 'Enter Active Port Used',
          aspectRatioLabel: 'Aspect Ratio',
          aspectRatioPlaceholder: 'Enter Aspect Ratio',
          brightnessLabel: 'Brightness',
          brightnessPlaceholder: 'Enter Brightness',
          colorGamutLabel: 'Color Gamut',
          colorGamutPlaceholder: 'Enter Color Gamut',
          contrastRatioLabel: 'Contrast Ratio',
          contrastRatioPlaceholder: 'Enter Contrast Ratio',
          displayArrangementLabel: 'Display Arrangement',
          displayArrangementPlaceholder: 'Enter Display Arrangement',
          displayTypeLabel: 'Display Type',
          displayTypePlaceholder: 'Enter Display Type',
          inputPortsLabel: 'Input Ports',
          inputPortsPlaceholder: 'Enter Input Ports',
          manufactureDateLabel: 'Manufacture Date',
          manufactureDatePlaceholder: 'Enter Manufacture Date',
          numberOfColorsLabel: 'Number of Colors',
          numberOfColorsPlaceholder: 'Enter Number of Colors',
          panelTypeLabel: 'Panel Type',
          panelTypePlaceholder: 'Enter Panel Type',
          refreshRateHzLabel: 'Refresh Rate (Hz)',
          refreshRateHzPlaceholder: 'Enter Refresh Rate (Hz)',
          resolutionHeightLabel: 'Resolution Height',
          resolutionHeightPlaceholder: 'Enter Resolution Height',
          resolutionWidthLabel: 'Resolution Width',
          resolutionWidthPlaceholder: 'Enter Resolution Width',
          rotationPivotModeLabel: 'Rotation/Pivot Mode',
          rotationPivotModePlaceholder: 'Enter Rotation/Pivot Mode',
          sizeInInchLabel: 'Size (Inch)',
          sizeInInchPlaceholder: 'Enter Size (Inch)',
          title: 'Monitor',
          touchCapabilityLabel: 'Touch Capability',
          touchCapabilityPlaceholder: 'Enter Touch Capability'
        },
        os: {
          antivirusSoftwareCompatibilityLabel: 'Antivirus Software Compatibility',
          antivirusSoftwareCompatibilityPlaceholder: 'Enter Antivirus Software Compatibility',
          architectureLabel: 'Architecture',
          architecturePlaceholder: 'Enter Architecture',
          automaticUpdatesEnabledLabel: 'Automatic Updates Enabled',
          bitnessLabel: 'Bitness',
          bitnessPlaceholder: 'Enter Bitness',
          buildNumberLabel: 'Build Number',
          buildNumberPlaceholder: 'Enter Build Number',
          firewallStatusLabel: 'Firewall Status',
          firewallStatusPlaceholder: 'Enter Firewall Status',
          kernelVersionLabel: 'Kernel Version',
          kernelVersionPlaceholder: 'Enter Kernel Version',
          operatingSystemTypeLabel: 'Operating System Type',
          operatingSystemTypePlaceholder: 'Enter Operating System Type',
          osEditionLabel: 'OS Edition',
          osEditionPlaceholder: 'Enter OS Edition',
          osNameLabel: 'OS Name',
          osNamePlaceholder: 'Enter OS Name',
          osSupportLifecycleLabel: 'OS Support Lifecycle',
          osSupportLifecyclePlaceholder: 'Enter OS Support Lifecycle',
          osVersionLabel: 'OS Version',
          osVersionPlaceholder: 'Enter OS Version',
          securityPatchDateLabel: 'Security Patch Date',
          securityPatchDatePlaceholder: 'Enter Security Patch Date',
          servicePackPatchLevelLabel: 'Service Pack/Patch Level',
          servicePackPatchLevelPlaceholder: 'Enter Service Pack/Patch Level',
          title: 'Operating System',
          withVirtualOsLabel: 'With Virtual OS'
        },
        osSetting: {
          bootModeLabel: 'Boot Mode',
          bootModePlaceholder: 'Enter Boot Mode',
          diskEncryptionEnabledLabel: 'Disk Encryption Enabled',
          osInstallDateLabel: 'OS Install Date',
          osInstallDatePlaceholder: 'Enter OS Install Date',
          title: 'OS Setting'
        },
        processor: {
          cpuCacheSizeL1BytesLabel: 'CPU L1 Cache Size (Bytes)',
          cpuCacheSizeL1BytesPlaceholder: 'Enter CPU L1 Cache Size (Bytes)',
          cpuCacheSizeL2BytesLabel: 'CPU L2 Cache Size (Bytes)',
          cpuCacheSizeL2BytesPlaceholder: 'Enter CPU L2 Cache Size (Bytes)',
          cpuCacheSizeL3BytesLabel: 'CPU L3 Cache Size (Bytes)',
          cpuCacheSizeL3BytesPlaceholder: 'Enter CPU L3 Cache Size (Bytes)',
          cpuClockSpeedHzLabel: 'CPU Clock Speed (Hz)',
          cpuClockSpeedHzPlaceholder: 'Enter CPU Clock Speed (Hz)',
          cpuCoreCountLabel: 'CPU Core Count',
          cpuCoreCountPlaceholder: 'Enter CPU Core Count',
          cpuGenerationLabel: 'CPU Generation',
          cpuGenerationPlaceholder: 'Enter CPU Generation',
          cpuMaxTurboFrequencyHzLabel: 'CPU Max Turbo Frequency (Hz)',
          cpuMaxTurboFrequencyHzPlaceholder: 'Enter CPU Max Turbo Frequency (Hz)',
          cpuNameLabel: 'CPU Name',
          cpuNamePlaceholder: 'Enter CPU Name',
          cpuProcessNodeLabel: 'CPU Process Node',
          cpuProcessNodePlaceholder: 'Enter CPU Process Node',
          cpuSeriesLabel: 'CPU Series',
          cpuSeriesPlaceholder: 'Enter CPU Series',
          cpuSocketTypeLabel: 'CPU Socket Type',
          cpuSocketTypePlaceholder: 'Enter CPU Socket Type',
          cpuTdpWattLabel: 'CPU TDP (Watt)',
          cpuTdpWattPlaceholder: 'Enter CPU TDP (Watt)',
          cpuThreadCountLabel: 'CPU Thread Count',
          cpuThreadCountPlaceholder: 'Enter CPU Thread Count',
          cpuVendorLabel: 'CPU Vendor',
          cpuVendorPlaceholder: 'Enter CPU Vendor',
          title: 'CPU'
        },
        ram: {
          ramEccSupportedLabel: 'ECC Supported',
          ramFormFactorLabel: 'RAM Form Factor',
          ramFormFactorPlaceholder: 'Enter RAM Form Factor',
          ramGenerationLabel: 'Memory Type',
          ramGenerationPlaceholder: 'Enter Memory Type',
          ramJedecCompliantLabel: 'JEDEC Compliant',
          ramManufactureDateLabel: 'RAM Manufacture Date',
          ramManufactureDatePlaceholder: 'Enter RAM Manufacture Date',
          ramManufacturerLabel: 'RAM Manufacturer',
          ramManufacturerPlaceholder: 'Enter RAM Manufacturer',
          ramPartNumberLabel: 'RAM Part Number',
          ramPartNumberPlaceholder: 'Enter RAM Part Number',
          ramRegisteredLabel: 'Registered RAM',
          ramSerialNumberLabel: 'RAM Serial Number',
          ramSerialNumberPlaceholder: 'Enter RAM Serial Number',
          ramSizeBytesLabel: 'RAM Size (Bytes)',
          ramSizeBytesPlaceholder: 'Enter RAM Size (Bytes)',
          ramSpeedHzLabel: 'RAM Speed (Hz)',
          ramSpeedHzPlaceholder: 'Enter RAM Speed (Hz)',
          title: 'RAM'
        },
        responsibilityOrg: {
          title: 'Organization'
        },
        responsibilityOwner: {
          title: 'Responsibility Owner'
        },
        software: {
          buildLabel: 'Build',
          buildPlaceholder: '(Windows)22H2, (macOS)12.1.2...',
          osLabel: 'OS',
          osPlaceholder: 'Select OS...',
          otherOSLabel: 'Other',
          title: 'Software',
          versionLabel: 'Version',
          versionPlaceholder: 'Ex) 11, Ventura...'
        },
        status: {
          currentStatusLabel: 'Current Status',
          currentStatusOptions: {
            ASSIGNED: 'Assigned',
            AVAILABLE: 'Available',
            PLACED: 'Placed',
            UNDER_PROCUREMENT: 'Under Procurement'
          },
          procurementDateLabel: 'Procurement Date',
          procurementTypeLabel: 'Procurement Type',
          title: 'Status'
        },
        storage: {
          capacityMBLabel: 'Capacity (MB)',
          capacityMBPlaceholder: 'Enter capacity in MB',
          nameLabel: 'Product Name / Model',
          namePlaceholder: 'Enter product name or model name',
          storageCacheSizeBytesLabel: 'Cache Size (Bytes)',
          storageCacheSizeBytesPlaceholder: 'Enter cache size in bytes',
          storageFirmwareVersionLabel: 'Firmware Version',
          storageFirmwareVersionPlaceholder: 'Enter firmware version',
          storageFormFactorLabel: 'Form Factor',
          storageFormFactorPlaceholder: 'Enter form factor',
          storageInterfaceTypeLabel: 'Interface Type',
          storageInterfaceTypePlaceholder: 'Enter interface type',
          storageManufacturerLabel: 'Manufacturer',
          storageManufacturerPlaceholder: 'Enter manufacturer',
          storageNandTypeLabel: 'NAND Type',
          storageNandTypePlaceholder: 'Enter NAND type',
          storageSerialNumberLabel: 'Serial Number',
          storageSerialNumberPlaceholder: 'Enter serial number',
          storageSlotNumberLabel: 'Slot Number',
          storageSlotNumberPlaceholder: 'Enter slot number',
          storageTrimSupportLabel: 'TRIM Support',
          storageTrimSupportPlaceholder: 'Is TRIM supported?',
          title: 'Storage',
          typeLabel: 'Storage Type',
          typePlaceholder: 'Select storage type'
        }
      },
      title: {
        hardware: 'Hardware',
        profile: 'Profile',
        software: 'Software'
      }
    },
    progressbar: {
      filled: 'filled',
      left: '{{value}}left',
      modeSetting: 'Mode Settings',
      mustItem: 'Must Item',
      mustItemOnly: 'Must item only',
      total: 'Total'
    }
  },
  intro: {
    body: {
      bulkAdd: 'Bulk add by uploading a csv file',
      fillOutDetails: 'Fill out the details',
      itemCard: {
        deviceCategory: 'Category',
        deviceName: 'Device Name',
        requiredDetails: 'Required details:',
        status: 'Status'
      },
      selectDeviceType: 'Select the Type:'
    },
    catalog: {
      completed: {
        message: 'Device created from catalog.'
      },
      description: 'Select catalog.',
      error: {
        unexpected: 'An unexpected error occurred'
      },
      fillDetails: 'Fill out details',
      form: {
        submit: 'Add device',
        title: 'Enter Device Details'
      },
      noSelection: 'Please select a catalog to continue.',
      title: 'Add Device data from catalog'
    },
    header: {
      headerTitle: 'Add Device data to your Inventory'
    },
    options: {
      addManually: {
        button: 'Proceed',
        description: 'You can add devices manually.',
        title: 'Add device data manually'
      },
      bulkCsvUpload: {
        button: 'Add',
        description: 'You can add data for multiple devices, up to 500 records at a time. A CSV file following the DRESS CODE format is required.',
        selectedDeviceType: 'Type:',
        title: 'Bulk add by uploading a csv file'
      },
      description: 'Or you might want to...',
      duplicateFromCatalog: {
        button: 'Proceed',
        description: 'You can add devices from the Catalog.',
        title: 'Add Device data from catalog'
      },
      syncIT: 'Sync with external IT-Device services'
    }
  }
};
export default pagesDevicesAddEn;